module.exports = __webpack_public_path__ + "static/media/sign-out.2a13f6d2.svg";